import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4802688"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "recommendation"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "recommendation__title" }, "Seus interesses", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_ctx.interestsTrainings.length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_carousel, {
          class: "carousel-recommended",
          settings: _ctx.recommendedSettings,
          breakpoints: _ctx.recommendedBreakpoints
        }, {
          addons: _withCtx(() => [
            _createVNode(_component_Navigation)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interestsTrainings, (interest, index) => {
              return (_openBlock(), _createBlock(_component_Slide, {
                key: interest.id
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Card, {
                    title: interest.title,
                    imageUrl: _ctx.formattedImageURL(interest.imageURL),
                    class: "recommendation_card",
                    onClick: ($event: any) => (_ctx.goToInterest(interest))
                  }, null, 8, ["title", "imageUrl", "onClick"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["settings", "breakpoints"])
      ]))
    : _createCommentVNode("", true)
}